import { Component, input, output } from '@angular/core';
import {
  FILING_UPLOAD_ACCEPT,
  FILING_UPLOAD_HINT,
  FILING_UPLOAD_LABEL,
} from '../../../engine/filing-upload';

@Component({
  selector: 'app-file-upload-zone',
  templateUrl: './file-upload-zone.component.html',
  styleUrl: './file-upload-zone.component.scss',
})
export class FileUploadZoneComponent {
  readonly label = input(FILING_UPLOAD_LABEL);
  readonly hint = input(FILING_UPLOAD_HINT);
  readonly accept = input(FILING_UPLOAD_ACCEPT);
  /** Allow multi-select for CSV packages; single file works for .zip and .xbrl. */
  readonly multiple = input(true);
  readonly disabled = input(false);

  readonly filesSelected = output<File[]>();

  protected onChange(event: Event): void {
    const inputEl = event.target as HTMLInputElement;
    const files = inputEl.files ? [...inputEl.files] : [];
    if (files.length) {
      this.filesSelected.emit(files);
    }
    inputEl.value = '';
  }

  protected onDrop(event: DragEvent): void {
    event.preventDefault();
    if (this.disabled()) return;
    const files = event.dataTransfer?.files ? [...event.dataTransfer.files] : [];
    if (files.length) {
      this.filesSelected.emit(files);
    }
  }

  protected onDragOver(event: DragEvent): void {
    event.preventDefault();
  }
}
